// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "a5b4a338ee73";
export const BUILD_VERSION_NUMBER = 22;
